import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system")({
  component: () => <Navigate to="/admin/design-system" />,
});
